import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Button,
  DialogFooter,
} from "@pushpress/pushpress-ui";
import { AlertTriangle } from "lucide-react";

type ExportPeopleModalProps = {
  closeModal: () => void;
  parentAccountName: string;
  isOpen: boolean;
  subAccountUserUuid: string;
  handleRemoveParentUser: (userUuid: string) => void;
  isUpdating: boolean;
};

export default function RemoveParentAccountModal({
  isOpen,
  closeModal,
  parentAccountName,
  subAccountUserUuid,
  handleRemoveParentUser,
  isUpdating,
}: ExportPeopleModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => closeModal()} modal>
      <DialogContent
        variant="noPadding"
        className="sm:max-w-[425px]"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="tw-pt-4 tw-pb-5 tw-border-b">
          <DialogTitle className="tw-text-neutral-800 tw-text-center !tw-font-medium tw-text-xl">
            Remove parent account
          </DialogTitle>
        </DialogHeader>
        <div className="tw-text-center tw-px-4">
          <AlertTriangle className="tw-h-10 tw-w-10 tw-text-error tw-mx-auto tw-mb-2.5" />
          <p className="tw-text-sm tw-text-neutral-600 tw-font-medium">
            Are you sure you want to remove{" "}
            <span className="tw-font-bold">{parentAccountName}</span> as the
            parent account?
          </p>
          <p className="tw-text-xs tw-text-neutral-500 tw-mt-1">
            This action cannot be undone.
          </p>
        </div>
        <DialogFooter className="tw-flex !tw-justify-between tw-border-t tw-py-6 tw-px-6 tw-mt-auto">
          <Button variant="outline" size="default" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            size="default"
            onClick={() => handleRemoveParentUser(subAccountUserUuid)}
            isSubmitting={isUpdating}
          >
            Remove
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
